import './OuraLogo.css'
import OuraImage from './oura_logo.png'
const OuraLogo = () => <img className="logo" src={OuraImage} />
export default OuraLogo
